import _ from 'lodash';

import {CREDIT_CARD_MACHINE} from 'ducks/tenancy';

import {formatDateForApi} from 'utils/datetime';

export const OTHER_LABEL = 'Other';

export const prepareDataForPost = ({
  oneOffChargeReason,
  description,
  amount,
  paymentMethod,
  paymentDate,
  invoiceDueDate,
  reference,
  batchNumber,
  creditCardNumber,
  createPayment,
  bookingId
}) => {
  const label = _.get(oneOffChargeReason, 'label');
  const paymentMethodValue = _.get(paymentMethod, 'value');

  let data: any = {
    bookingId,
    description,
    amount,
    label,
    invoiceDueDate: invoiceDueDate && formatDateForApi(invoiceDueDate),
    oneOffChargeReasonId: _.get(oneOffChargeReason, 'id')
  };

  if (createPayment) {
    const paymentData = {
      reference,
      paymentMethod: paymentMethodValue,
      paymentDate: paymentDate && formatDateForApi(paymentDate),
      createPayment
    };

    data = {...data, ...paymentData};
  }

  if (paymentMethodValue == CREDIT_CARD_MACHINE) {
    data = {
      ...data,
      batchNumber,
      creditCardNumber
    };
  }

  if (!_.isNil(oneOffChargeReason) && label !== OTHER_LABEL) {
    data = {...data, ...{xeroAccount: oneOffChargeReason.xeroAccount.id}};
  }

  return data;
};
